import { create } from "zustand";
import { getMe, loginWithPassword as apiLoginWithPassword, logout as apiLogout, registerWithPassword as apiRegisterWithPassword, requestMagicLink as apiRequestMagicLink, type User } from "./api";

interface AuthStore {
  user: User | null;
  loading: boolean;
  initialized: boolean;
  requestMagicLink: (email: string) => Promise<string>;
  loginWithPassword: (email: string, password: string) => Promise<void>;
  registerWithPassword: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
}

export const useAuth = create<AuthStore>((set) => ({
  user: null,
  loading: false,
  initialized: false,

  requestMagicLink: async (email: string) => {
    set({ loading: true });
    try {
      const { message } = await apiRequestMagicLink(email);
      set({ loading: false });
      return message;
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  loginWithPassword: async (email: string, password: string) => {
    set({ loading: true });
    try {
      const { user } = await apiLoginWithPassword(email, password);
      set({ user, initialized: true, loading: false });
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  registerWithPassword: async (email: string, password: string) => {
    set({ loading: true });
    try {
      const { user } = await apiRegisterWithPassword(email, password);
      set({ user, initialized: true, loading: false });
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  logout: async () => {
    await apiLogout();
    set({ user: null });
  },

  checkAuth: async () => {
    try {
      const { user } = await getMe();
      set({ user, initialized: true });
    } catch {
      set({ user: null, initialized: true });
    }
  },
}));
